import { has, get } from 'lodash';

export const isLoading = (state, { id }) => get(state.ui.asyncStatus, `${id}.loading`, false);
export const hasError = (state, { id }) => has(state.ui.asyncStatus, `${id}.error`);
export const getError = (state, { id }) => get(state.ui.asyncStatus, `${id}.error`);
